import { Plus } from "lucide-react";
import { useState } from "react";


import Button from "@/components/buttons/Button";
import Table from "@/components/Table";
import ComplaintsModal from "../fragments/complaints-modal";
import ComplaintListItem from "../fragments/complaints-item";
import Pagination from "@/components/Pagination";
import { Outlet } from "react-router-dom";
import { useComplaints } from "../repositories/complaints-repository";



export default function Complaints() {
    const [open, setOpen] = useState(false);
    const [page, setPage] = useState<number>(1);
    // GET /complaints takes a Pageable only - the API exposes no search,
    // status or date filter for complaints, so no filter bar is rendered.
    const { complaints ,isLoading} = useComplaints({
        pager: { page, size: 10 }
    })
  

    const columns = [
        "Complaints ID", 
        "Subject", 
        "Type", 
        "Submission Date", 
        "Status",
        "Action"
    ]

    return (
        <div className="mt-5 px-4">
            <Outlet />
            <ComplaintsModal
                isOpen={open}
                onClose={() => setOpen(!open)}

            />
            <div className="flex justify-end items-center">
                    <Button
                        onClick={() => setOpen(true)}
                        intent="primary"
                        size="md"
                        leftIcon={<Plus size={20} />}
                    >
                        New Complaints
                    </Button>
            </div>
            <Table.Container>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            {
                                columns.map((header) => (
                                    <Table.Head key={header}>
                                        {header}
                                    </Table.Head>
                                ))
                            }
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {
                            isLoading && (
                            <Table.Loading columns={columns.length} />
                        )}

                        {
                            complaints && complaints.results.length == 0 && (
                                <Table.Empty />
                            )
                        }

                        {
                          complaints &&  complaints.results.map((complaint:any) => (
                                <ComplaintListItem complaint={complaint} key={complaint.id} />
                            ))
                        }
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.Cell colSpan={columns.length}>
                                <div className="flex justify-between items-center font-light">
                                    <div>
                                        {complaints?.pagination?.numberOfElements} Complaints
                                    </div>
                                    <Pagination
                                        currPage={complaints?.pagination?.current_page ?? 0}
                                        setCurrPage={(value) => setPage(value + 1)}
                                        pageCount={complaints?.pagination?.last_page ?? 0}
                                    />
                                </div>
                            </Table.Cell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </Table.Container>
        </div>
    )
}